module.exports = __webpack_public_path__ + "c2ff2c1309ddcbdb45565a50bfd2b297.svg";